// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  threadMessageId: __t.u64().primaryKey().name("thread_message_id"),
  threadId: __t.u64().name("thread_id"),
  authorKind: __t.string().name("author_kind"),
  authorIdentity: __t.string().name("author_identity"),
  authorAgentId: __t.u64().name("author_agent_id"),
  body: __t.string(),
  createdAt: __t.i64().name("created_at"),
});
